<template>
	<div class="content" style="padding-top: 50px;">

		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-medium-size-25 md-size-25"></div>

			<div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-50">

				<md-card>
					<md-card-header data-background-color="purple">
						<h4 class="title">ការភ្ជាប់គណនីអតិថិជន</h4>
					</md-card-header>
					<md-card-content>
						<div class="md-layout" v-if="!success">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h4>សូមបញ្ចូលលេខកូដអតិថិជន</h4>
								<p style="color: red" v-if="fail">{{message}}</p>
							</div>

							<div class="md-layout-item md-small-size-100 md-size-100">
								<md-field>
									<label>លេខកូដអតិថិជន *</label>
									<md-input type="text" v-model="client_hash" @keyup="clearMessage()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<md-button class="md-raised md-primary" style="width: 100%" type="submit" @click="setup()">ភ្ជាប់គណនី</md-button>
							</div>
						</div>

						<div class="md-layout" v-if="success">
							<div class="md-layout-item md-small-size-100 md-size-100 text-center">
								<img src="@/assets/img/tick.png" style="width: 30%" />
								<h4>អ្នកបានភ្ជាប់គណនីដោយជោគជ័យ។</h4>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>

			<div class="md-layout-item md-small-size-100 md-medium-size-25 md-size-25"></div>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
		},

		data() {
			return {
				client_hash: "",
				success: false,
				fail: false,
				message: ""
			}
		},
		methods: {
			setup() {
				if (String(this.client_hash).length > 5 && String(this.$route.params.chat_id).length > 5) {
					this.$http.post(this.config.api + "/public/link_telegram", {
						hash: this.client_hash,
						chat_id: this.$route.params.chat_id
					}).then(data => {
						if (data.body.status == 'success') {
							this.success = true;
						} else {
							this.fail = true;
							this.message = data.body.data.message;
						}
					})
				} else {
					this.fail = true;
					this.message = "សូមបំពេញព័ត៌មាន!"
				}
			},
			clearMessage() {
				this.fail = false;
				this.message = "";
			}
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Link.vue